import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const COLORS = {
  'High': '#F44336',
  'Medium': '#FF9800',
  'Low': '#4CAF50'
};

const ObjectivesEffortChart = ({ data }) => {
  // Count objectives by estimated effort
  const effortCounts = {};
  data.forEach(obj => {
    const effort = obj.estimated_effort || 'Unknown';
    effortCounts[effort] = (effortCounts[effort] || 0) + 1;
  });

  const chartData = Object.keys(effortCounts).map(key => ({
    name: key,
    count: effortCounts[key],
    color: COLORS[key] || '#9E9E9E'
  })).sort((a, b) => {
    const order = { 'High': 1, 'Medium': 2, 'Low': 3, 'Unknown': 4 };
    return (order[a.name] || 99) - (order[b.name] || 99);
  });

  const hasData = chartData.length > 0;

  const renderCustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <div style={{
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '10px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        }}>
          <p style={{ margin: 0, fontWeight: 'bold', color: '#000' }}>
            {`${data.payload.name}: ${data.value} objective${data.value !== 1 ? 's' : ''}`}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer height={300} width="100%">
      {hasData ? (
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={renderCustomTooltip} />
          <Legend />
          <Bar dataKey="count" name="Number of Objectives" radius={[8, 8, 0, 0]}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      ) : (
        <div style={{
          height: 300,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          color: '#888'
        }}>
          No Data Available
        </div>
      )}
    </ResponsiveContainer>
  );
};

ObjectivesEffortChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    estimated_effort: PropTypes.string,
  })).isRequired,
};

export default ObjectivesEffortChart;

